var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Tommorow"},[_vm._v(" Tommorow - завтра ")])}
var staticRenderFns = []

export { render, staticRenderFns }